import React from 'react';

const Separator = ({ darkMode }) => (
    <div className={`h-px mx-2 my-1 ${darkMode ? 'bg-white/10' : 'bg-gray-200'}`} />
);

export default Separator;
